var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickReferenceAll({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7652_2256",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7652_2256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99997 3.99998V10.1788V10.1538V20V3.99998ZM7.25 13.75H10.7981C10.9224 13.4628 11.0673 13.1958 11.2327 12.949C11.3981 12.7022 11.584 12.4692 11.7903 12.25H7.25V13.75ZM7.25 17.75H10.2807C10.2231 17.5 10.1849 17.25 10.1663 17C10.1477 16.75 10.1487 16.5 10.1692 16.25H7.25V17.75ZM5.3077 21.5C4.80257 21.5 4.375 21.325 4.025 20.975C3.675 20.625 3.5 20.1974 3.5 19.6923V4.3077C3.5 3.80257 3.675 3.375 4.025 3.025C4.375 2.675 4.80257 2.5 5.3077 2.5H13.25L18.5 7.74995V10.5096C18.2602 10.4147 18.0153 10.3426 17.7654 10.2933C17.5154 10.2439 17.2602 10.2058 17 10.1788V8.49995H12.5V3.99998H5.3077C5.23077 3.99998 5.16024 4.03203 5.09612 4.09613C5.03202 4.16024 4.99997 4.23077 4.99997 4.3077V19.6923C4.99997 19.7692 5.03202 19.8397 5.09612 19.9038C5.16024 19.9679 5.23077 20 5.3077 20H11.2077C11.4038 20.2974 11.6237 20.5721 11.8673 20.824C12.1109 21.0759 12.375 21.3012 12.6596 21.5H5.3077ZM16.5 19.1538C17.2449 19.1538 17.8734 18.8977 18.3856 18.3856C18.8977 17.8734 19.1538 17.2449 19.1538 16.5C19.1538 15.7551 18.8977 15.1266 18.3856 14.6144C17.8734 14.1022 17.2449 13.8461 16.5 13.8461C15.7551 13.8461 15.1266 14.1022 14.6144 14.6144C14.1022 15.1266 13.8461 15.7551 13.8461 16.5C13.8461 17.2449 14.1022 17.8734 14.6144 18.3856C15.1266 18.8977 15.7551 19.1538 16.5 19.1538ZM21.6 22.6442L18.8615 19.9057C18.5243 20.1519 18.1548 20.3381 17.7529 20.4644C17.3509 20.5907 16.9333 20.6538 16.5 20.6538C15.3461 20.6538 14.3654 20.25 13.5577 19.4423C12.75 18.6346 12.3461 17.6538 12.3461 16.5C12.3461 15.3461 12.75 14.3654 13.5577 13.5577C14.3654 12.75 15.3461 12.3462 16.5 12.3462C17.6538 12.3462 18.6346 12.75 19.4423 13.5577C20.25 14.3654 20.6538 15.3461 20.6538 16.5C20.6538 16.9333 20.5907 17.3509 20.4644 17.7529C20.3381 18.1548 20.1519 18.5243 19.9057 18.8615L22.6442 21.6L21.6 22.6442Z",
    fill: "#0048B6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickReferenceAll);
export default __webpack_public_path__ + "static/media/quick_reference_all.ff6b39c97dc4b17aa8d60364a53a54a4.svg";
export { ForwardRef as ReactComponent };